import React, { useState, useRef, useEffect } from "react";
import { ModernDropdownContent } from "./ModernDropdownContent.js";
import { ModernDropdownTitle } from "./ModernDropdownTitle.js";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";

import "./ModernDropdown.scss";

const ModernDropdown = ({
  children,
  selectList,
  selectObject,
  handleChange,
  title,
  showDropDownExternal = null,
  setShowDropDownExternal,
  className,
  isChangeTitle,
  additionalElement,
  //some dropdowns dont yet have default values this prevents it from crashing
  defaultValue = title,
  isDropDownOpen = null,
  direction,
}) => {
  const [showDropDown, setShowDropDown] = useState(showDropDownExternal);
  const [dropdownTitle, setDropdownTitle] = useState(defaultValue);

  const ref = useRef();
  useOnClickOutside(ref, () => setShowDropDown(false));

  useEffect(() => {
    isDropDownOpen(showDropDown);
  }, [showDropDown]);

  useEffect(() => {
    setShowDropDown(showDropDownExternal);
  }, [showDropDownExternal]);

  const handleClickDropDown = () => {
    setShowDropDownExternal((prev) => !prev);
  };

  return (
    <AnimationContainer
      animationOn={showDropDown}
      animationClassName="dropdown"
      containerElementClassName={`modern-dropdown ${
        className ? className : ""
      }`}
      timeout={600}
      isUnmountOnExit={false}
    >
      <div ref={ref} onClick={() => handleClickDropDown()}>
        <ModernDropdownTitle
          {...{ children, additionalElement, dropdownTitle, direction }}
        />
        <ModernDropdownContent
          {...{
            setShowDropDown,
            setDropdownTitle,
            handleChange,
            selectList,
            selectObject,
            isChangeTitle,
            showDropDown,
            direction,
          }}
        />
      </div>
    </AnimationContainer>
  );
};

ModernDropdown.defaultProps = {
  selectList: [],
  title: "",
  className: "",
  isChangeTitle: true,
};

export default ModernDropdown;
